import Vue from 'vue';
import LogService from '../services/logging/log.service.client';

export default ({ store, $justLog, $sentry }, inject) => {
    const logService = new LogService($sentry, $justLog, store);

    inject('log', logService);

    Vue.config.errorHandler = (error, vm, info) => {
        logService.error(`Unhandled error: ${error.message}`, error, ['unhandled-error'], {
            error,
            info
        });
    };
};
